/* eslint-disable */
import axios from 'axios';
const AJAX_URL = process.env.VUE_APP_AJAX_URL;

export async function sendTransitionTrackingData(eventType, fromStateDisplay, toStateDisplay, fromMachineState, toMachineState, transitionCount, uuid) {
    /*try {
        await axios.post(AJAX_URL, {
            request: 701,
            uuid: uuid,
            steps: transitionCount,
            from_view: fromMachineState,
            to_view: toMachineState,
            title: toStateDisplay,
            type: eventType,
        });
    } catch (error) {
        console.error('Fehler beim Senden der Workflow-Tracking-Daten:', error);
    }*/
}

export async function sendPlzTrackingData(uuid, zipcode, status){
    /*try {
        await axios.post(AJAX_URL, {
            request: 702,
            uuid: uuid,
            zipcode: zipcode,
            status: status,
        });
    } catch (error) {
        console.error('Fehler beim Senden der PLZ-Tracking-Daten:', error);
    }*/
}